const B_1 = [
    {
        title: '公告',
        path: '/bidding/projectflow/fabiao/zbgg/zfcg/list'
    }
]
export default {
    path: 'zfcg',
    component: () => import(/*webpackChunkName: 'bidding-projectflow-fabiao-zbgg-zfcg'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/project-flow/fa/zbgg/zfcg/list'),
            meta: {
                title: '公告列表',
                bread: B_1
            },
        },
        {
            path:"form",
            component: () => import('@views/bidding/views/project-flow/fa/zbgg/zfcg/form'),
            meta: {
                title: '公告信息',
                bread: '/bidding/projectflow/fabiao/zbgg/zfcg/form'
            },
        },
        {
            path:"detail",
            component: () => import('@views/bidding/views/project-flow/fa/zbgg/zfcg/detail'),
            meta: {
                title: '详细信息',
                bread: '/bidding/projectflow/fabiao/zbgg/zfcg/detail'
            },
        },
    ]
}